import { render, staticRenderFns } from "./PRadio.vue?vue&type=template&id=4239053e"
import script from "./PRadio.vue?vue&type=script&lang=js"
export * from "./PRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports